"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tabs.default;
  }
});
Object.defineProperty(exports, "TabNav", {
  enumerable: true,
  get: function get() {
    return _TabNav.default;
  }
});
Object.defineProperty(exports, "TabContents", {
  enumerable: true,
  get: function get() {
    return _TabContents.default;
  }
});
Object.defineProperty(exports, "TabTitle", {
  enumerable: true,
  get: function get() {
    return _TabTitle.default;
  }
});
Object.defineProperty(exports, "TabSection", {
  enumerable: true,
  get: function get() {
    return _TabSection.default;
  }
});

var _Tabs = _interopRequireDefault(require("./Tabs"));

var _TabNav = _interopRequireDefault(require("./TabNav"));

var _TabContents = _interopRequireDefault(require("./TabContents"));

var _TabTitle = _interopRequireDefault(require("./TabTitle"));

var _TabSection = _interopRequireDefault(require("./TabSection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }